<div class="container">
    <login-form [config]="loginFormConfig"></login-form>
</div>